import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Image, List } from 'antd'
import {
    WhatsAppOutlined,
    MailOutlined,
    GithubOutlined,
    FacebookOutlined,
    TwitterOutlined,
    InstagramOutlined,
    LinkedinOutlined
} from '@ant-design/icons'

import { Seo } from '../components/seo'
import UseLocalized from '../utils/localized'
import useTranslations from '../utils/translations'

import Developer from '../images/developer.png'
import CV from '../data/pdf/cv.pdf'

const Section = styled.section`
    ${tw`px-12 lg:px-40 py-12 pt-12 lg:pt-24`}
`
const Content = styled.div`
    ${tw`flex flex-wrap`}
`
const Aboutl = styled.div`
    ${tw`w-full lg:w-1/4`}
`
const Aboutr = styled.div`
    ${tw`w-full lg:w-3/4 pl-0 lg:pl-16`}
`
const Work = styled.div`
    ${tw`w-full lg:w-1/2 px-0 lg:px-2`}
`
const Contact = styled.div`
    ${tw`w-full lg:w-1/3`}
`
const H1 = styled.h1`
    ${tw`text-3xl md:text-7xl font-normal tracking-widest leading-normal md:leading-relaxed`}
`
const H31 = styled.h3`
    ${tw`text-6xl font-bold tracking-widest leading-normal md:leading-relaxed`}
`
const H32 = styled.h3`
    ${tw`text-4xl font-bold tracking-widest leading-normal md:leading-relaxed`}
`
const P1 = styled.p`
    ${tw`leading-normal md:leading-loose tracking-widest font-bold`}
`
const P2 = styled.p`
    ${tw`leading-normal md:leading-loose tracking-widest font-light`}
`
const Button = styled.button`
    ${tw`border-2 rounded-md text-xs border-black py-3 px-5 text-black hover:text-white hover:bg-black`}
`
const Socialmedia = styled.a`
    ${tw`text-black`}
`

const HomePage = () => {
    const {
        greeting, jundana, experience,
        about_title, about_content_01, about_content_02, about_button,
        work_title, work_subtitle, work_content_01, work_content_02, work_button,
        contact_title, contact_subtitle, contact_content_01, contact_content_02
    } = useTranslations()

    return (
        <>
            <Seo title={"Jundana Al-Basyir | Home"} />
            <Section>
                <H1>
                    {greeting}
                    <br />
                    {jundana}
                    <br />
                    {experience}
                </H1>
            </Section>
            <Section>
                <Content>
                    <Aboutl>
                        <H32>{about_title}</H32>
                    </Aboutl>
                    <Aboutr>
                        <P2>{about_content_01}</P2>
                        <P2>{about_content_02}</P2>
                        <UseLocalized href={CV} rel="noopener noreferrer" target="_blank">
                            <Button>
                                {about_button}
                            </Button>
                        </UseLocalized>
                    </Aboutr>
                </Content>
            </Section>
            <Section>
                <H31>{work_title}</H31>
                <Content>
                    <Work>
                        <Image src={Developer} />
                    </Work>
                    <Work>
                        <P1>{work_subtitle}</P1>
                        <P2>{work_content_01}</P2>
                        <P2>{work_content_02}</P2>
                        <UseLocalized to={`/work`}>
                            <Button>
                                {work_button}
                            </Button>
                        </UseLocalized>
                    </Work>
                </Content>
            </Section>
            <Section>
                <H31>{contact_title}</H31>
                <Content>
                    <Contact>
                        <P1>{contact_subtitle}</P1>
                        <P2>{contact_content_01}</P2>
                        <P2>{contact_content_02}</P2>
                        <List
                            itemLayout="vertical">
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<WhatsAppOutlined />}
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Whatsapp" href="https://api.whatsapp.com/send?phone=6281395204900">+62 81395204900</Socialmedia>}
                                />
                                <List.Item.Meta
                                    avatar={<MailOutlined />}
                                    description={<Socialmedia href="mailto:jundanadeveloper@gmail.com">jundanadeveloper@gmail.com</Socialmedia>}
                                />
                            </List.Item>
                        </List>
                        <List
                            itemLayout="horizontal">
                            <List.Item>
                                <List.Item.Meta
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Linkedin" style={{ fontSize: '150%' }} href="https://www.linkedin.com/in/jundanaalbasyir/"><LinkedinOutlined /></Socialmedia>}
                                />
                                <List.Item.Meta
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Github" style={{ fontSize: '150%' }} href="https://github.com/jundanaalbasyir"><GithubOutlined /></Socialmedia>}
                                />
                                <List.Item.Meta
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Facebook" style={{ fontSize: '150%' }} href="https://www.facebook.com/jundana.albasyir/"><FacebookOutlined /></Socialmedia>}
                                />
                                <List.Item.Meta
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Twitter" style={{ fontSize: '150%' }} href="https://twitter.com/justjundana"><TwitterOutlined /></Socialmedia>}
                                />
                                <List.Item.Meta
                                    description={<Socialmedia target="_blank" rel="noreferrer" aria-label="Instagram" style={{ fontSize: '150%' }} href="http://instagram.com/justjundana"><InstagramOutlined /></Socialmedia>}
                                />
                            </List.Item>
                        </List>
                    </Contact>
                </Content>
            </Section>
        </>
    )
}

export default HomePage